import { render, staticRenderFns } from "./DetailPlayback.vue?vue&type=template&id=12b16ed7&scoped=true&"
import script from "./DetailPlayback.vue?vue&type=script&lang=ts&"
export * from "./DetailPlayback.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPlayback.vue?vue&type=style&index=0&id=12b16ed7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b16ed7",
  null
  
)

export default component.exports